module.exports = __webpack_public_path__ + "static/images/components/Back/images/info.7e69f346.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/info.png
// module id = 2495
// module chunks = 11